import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f392021"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"position":"relative"},
  class: "chart-container"
}
const _hoisted_2 = { class: "download-icon" }
const _hoisted_3 = ["id"]
const _hoisted_4 = { style: {"position":"absolute","top":"1rem","right":"1rem"} }

import { hexToRgba } from '@/utils/utilsHandle';
import { computed, reactive, ref } from 'vue';
import VChart from 'vue-echarts';
import html2canvas from 'html2canvas';


export default /*#__PURE__*/_defineComponent({
  props: {
  categories: {
    type: Array as () => string[],
    default: [],
  },
  values: {
    type: Array as () => Array<Array<number>>,
    default: [],
  },
},
  setup(__props) {

const props = __props



const id = ref('rader-' + Math.random());
const state = reactive({
  show: false,
});

const options = computed(() =>
  props.categories.length > 3
    ? getRadarOptions(props.categories, props.values)
    : getBarOptions(props.categories, props.values)
);

const lightModeOptions = computed(() =>
  props.categories.length > 3
    ? getRadarOptions(props.categories, props.values, true)
    : getBarOptions(props.categories, props.values, true)
);
const colors = ['#00fa99', '#37fdff', '#fac800', '#ff6c00', '#f03200'];
const colors1 = ['#00fa99', '#00fa99', '#fac800', '#f03200', '#f03200'];
colors.reverse();
colors1.reverse();
const flag = ref(false);
const getRadarOptions = (
  categories: Array<string>,
  values: Array<Array<number>>,
  lightMode = false
) => {
  const splitNumber = 5;
  return {
    tooltip: { trigger: 'item' },
    radar: {
      startAngle: 0,
      radius: '50%',
      indicator: categories.map((category) => ({ name: category, max: 5 })),
      splitNumber: splitNumber,
      name: {
        textStyle: {
          color: lightMode ? 'rgba(0, 0, 0, 0.9)' : '#fff',
          backgroundColor: 'transparent',
          borderRadius: 3,
          padding: [3, 5],
          fontFamily: 'custom',
          fontWeight: 500,
        },
      },

      splitLine: {
        lineStyle: {
          color: lightMode ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.5)',
          width: 1,
        },
      },
      axisLine: {
        show: false,
      },
      axisLabel: {
        show: true,
        formatter: (() => {
          // 使用闭包记录每个值的调用次数
          let callCount = {};
          let renderCount = 0;
          return function(value, index) {
            // 检测是否是新一轮完整渲染
            // 当 value === 0 时，说明开始新的一个轴
            // 当遍历完所有轴后（renderCount 达到阈值），重置计数器
            if (value === 0) {
              renderCount++;
              // 如果已经遍历了足够多次（超过轴数量），说明是新一轮渲染
              if (renderCount > categories.length) {
                callCount = {};
                renderCount = 1;
              }
            }
            
            // 初始化计数器
            if (!callCount[value]) {
              callCount[value] = 0;
            }
            callCount[value]++;
            
            // 只在第一次调用时返回值（显示在第一个轴上）
            // 且不显示 0
            if (callCount[value] === 1 && value > 0) {
              return value;
            }
            return '';
          };
        })(),
      },
      splitArea: {
        areaStyle: {
          color: 'transparent',
        },
      },
    },
    series: values.map((value, index) => ({
      name: '风险定级',
      type: 'radar',
      color: '#FAA500',
      data: [
        {
          value,
          name: '风险定级',
          symbolSize: 2,
          lineStyle: {
            width: 1,
          },
          areaStyle: {
            color: hexToRgba('#FAA500', 0.2),
          },
          axisLine: {
            show: true,
          },
        },
      ],
    })),
  };
};

const getBarOptions = (
  categories: Array<string>,
  values: Array<Array<number>>,
  lightMode = false
) => {
  return {
    tooltip: { trigger: 'item' },
    xAxis: {
      type: 'category',
      data: categories,
      axisLabel: {
        fontFamily: 'custom',
        fontWeight: 500,
      },
    },
    yAxis: {
      type: 'value',
      max: 5,
      axisLine: {
        // 设置轴线样式
        show: true,
        lineStyle: {
          color: '#333', // 轴线颜色
          width: 1, // 轴线宽度
        },
      },
      axisTick: {
        // 设置刻度线样式
        show: true,
        lineStyle: {
          color: '#333', // 刻度线颜色
          width: 1, // 刻度线宽度
        },
      },
      splitLine: {
        // 设置分隔线样式
        show: true,
        lineStyle: {
          type: 'dashed', // 设置为虚线
          color: '#999', // 分隔线颜色
        },
      },
      axisLabel: {
        // 设置标签样式
        color: 'rgba(0, 0, 0, 0.9)', // 标签颜色
      },
    },
    series: values.map((value) => ({
      data: value,
      type: 'bar',
      barWidth: '25%',
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)',
      },
      itemStyle: {
        // 使用回调函数设置柱子颜色
        color: function (params: any) {
          // 根据值的大小返回不同的颜色
          var value = params.value;
          if (value > 0) {
            return colors[Number.parseInt(value) - 1];
          }
          return '#159aff';
        },
      },
    })),
  };
};

const toDownload = () => {
  state.show = true;
};

const download = async () => {
  {
    const element = document.getElementById(id.value); // 要下载的 HTML 元素
    if (!element) {
      console.error('Element not found');
      return;
    }

    try {
      // 使用 html2canvas 将 HTML 元素转换为 Canvas
      const canvas = await html2canvas(element);

      // 将 Canvas 转换为图片格式（这里使用 PNG 格式）
      const imageData = canvas.toDataURL('image/png');

      // 创建一个 <a> 元素，用于下载图片
      const downloadLink = document.createElement('a');
      downloadLink.href = imageData;
      downloadLink.download = 'element-screenshot.png'; // 设置下载文件的名称

      // 将 <a> 元素添加到 DOM 中，模拟点击下载
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // 下载完成后，移除 <a> 元素
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error('Failed to capture screenshot:', error);
    }
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Download = _resolveComponent("Download")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(VChart), {
        style: {"width":"100%","height":"8rem"},
        option: _unref(options),
        autoresize: true
      }, null, 8, ["option"]),
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_icon, {
          style: {"font-size":"0.5rem"},
          onClick: toDownload
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Download)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(state).show,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).show) = $event)),
      style: {"width":"20rem"},
      title: "下载图例"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            id: id.value,
            style: {"width":"20rem","height":"20rem"}
          }, [
            _createVNode(_unref(VChart), {
              style: {"width":"20rem","height":"20rem"},
              option: _unref(lightModeOptions),
              autoresize: true
            }, null, 8, ["option"])
          ], 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer","font-size":"1rem"},
              onClick: download
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Download)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})